import { Link } from "react-router-dom";
import { OFFICIAL_LOGO_URL, PROPERTY, NAV_LINKS } from "@/lib/constants";
import BookButton from "@/components/BookButton";
import CitationsBar from "@/components/CitationsBar";

export default function Footer() {
  return (
    <footer className="bg-ink text-canvas relative overflow-hidden" data-testid="site-footer">
      <div className="grain" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4 mb-6">
            <img src={OFFICIAL_LOGO_URL} alt="Westbridge Inn & Suites official logo" className="w-24 h-24 rounded-sm" />
            <div>
              <p className="font-display text-3xl">Westbridge</p>
              <p className="font-mono-label text-canvas/60">Inn &amp; Suites · Carrollton, MO</p>
            </div>
          </div>
          <p className="font-display text-3xl md:text-4xl leading-[1.15] text-canvas/95 max-w-md">
            A clean room, a quiet night, and a warm welcome on US&nbsp;Highway&nbsp;65.
          </p>
          <div className="mt-8">
            <BookButton label="Reserve Now" testid="footer-book-btn" />
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono-label text-canvas/50 mb-4">Visit</p>
          <address className="not-italic font-sans text-canvas/85 leading-relaxed">
            {PROPERTY.street}<br />
            {PROPERTY.cityState}
          </address>
          <div className="mt-6 space-y-1">
            <p className="font-mono-label text-canvas/50">Front desk · 24h</p>
            <a href={`tel:${PROPERTY.phone.replace(/[^\d+]/g, "")}`} className="link-underline text-canvas font-display text-2xl" data-testid="footer-phone">
              {PROPERTY.phone}
            </a>
          </div>
          <div className="mt-4 space-y-1">
            <p className="font-mono-label text-canvas/50">Email</p>
            <a href={`mailto:${PROPERTY.email}`} className="link-underline text-canvas break-all" data-testid="footer-email">
              {PROPERTY.email}
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono-label text-canvas/50 mb-4">Explore</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="link-underline text-canvas/85 hover:text-canvas">
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/about" className="link-underline text-canvas/85 hover:text-canvas">
                Our Story
              </Link>
            </li>
            <li>
              <Link to="/accessibility" className="link-underline text-canvas/85 hover:text-canvas">
                Accessibility
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono-label text-canvas/50 mb-4">Policies</p>
          <ul className="space-y-3 text-canvas/85">
            <li>Check-in {PROPERTY.checkIn}</li>
            <li>Check-out {PROPERTY.checkOut}</li>
            <li>Pet friendly · 2 pets/room</li>
            <li>Trucker rate — ask by phone</li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-canvas/15">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col gap-4">
          <CitationsBar className="!text-canvas/85 [&_a]:text-canvas/85 [&_a:hover]:text-canvas [&_span]:text-canvas/50" />
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 pt-2 border-t border-canvas/10">
            <p className="font-mono-label text-canvas/45">
              © {new Date().getFullYear()} Westbridge Inn &amp; Suites · Independently owned &amp; operated
            </p>
            <p className="font-mono-label text-canvas/45">
              Great service · Clean rooms · Transparent pricing
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
